// src/pages/EducationPage.tsx
import React, { useState, useEffect } from 'react';
import { getEducation, Education } from '../api/educationService';
import './EducationPage.css';

const EducationPage: React.FC = () => {
  const [education, setEducation] = useState<Education[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchEducation = async () => {
      try {
        const data = await getEducation();
        // Sort by year_end (most recent first)
        const sortedData = [...data].sort((a, b) => (b.year_end ?? 9999) - (a.year_end ?? 9999));
	// const sortedData = [...data].sort((a, b) => b.year_end - a.year_end);
        setEducation(sortedData);
      } catch (err: any) {
        console.error('Error fetching education:', err);
        setError(`Failed to load education: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchEducation();
  }, []);

  if (loading) return <div className="education-container"><p>Loading education history...</p></div>;
  if (error) return <div className="education-container"><p className="error">{error}</p></div>;

  return (
    <div className="education-container">
      <h1>Education</h1>
      
      {education.length === 0 ? (
        <p>No education history found.</p>
      ) : (
        <div className="education-timeline">
          {education.map((edu) => (
            <div key={edu.id} className="education-item">
              <div className="education-year">
                {edu.year_start} - {edu.year_end}
              </div>
              <div className="education-content">
                <h2 className="education-degree">
                  {edu.degree} in {edu.specialization}
                </h2>
                <h3 className="education-university">{edu.university}</h3>
                <p className="education-location">{edu.location}</p>
                {edu.description && (
                  <p className="education-description">{edu.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EducationPage;
